import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, renderList as _renderList, createSlots as _createSlots, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6ae89729"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "header-padding" }, "Device details", -1))
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Policy", -1))
const _hoisted_4 = { class: "expected-policy" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Details", -1))

import { computed, onMounted } from 'vue'
import { DeviceSchema, MdmDeviceSchema, MdmPolicySchema } from '@/generated/sdk'

import { router } from '@/plugins/router'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'

import { useProvideDevice } from '..'
import DeviceDetailsTable from './DeviceDetailsTable.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'DeviceDetailsPage',
  setup(__props) {

const { setDevice, device, groupedDeviceDetails } = useProvideDevice()

const route = useRoute()
const store = useStore()
const mdmPolicies = computed<MdmPolicySchema[]>(() => store.state.policies.mdmPolicies)

const mdmDevice = computed<MdmDeviceSchema>(() => device.value.mdmDevice)
const googleDevice = computed<DeviceSchema>(() => device.value.googleDevice)

onMounted(async () => {
  const mdmDeviceId = route.params.id as string
  await setDevice(mdmDeviceId)
})

async function updateMdmDevicePolicy(e: MdmDeviceSchema): Promise<void> {
  const confirmMessage = `Update device with IMEI: ${e.imei} to "${formatPolicyName(e.policyName)}"?`
  if (window.confirm(confirmMessage)) {
    await store.dispatch('updateMdmDevices', [
      {
        id: e.id,
        googleId: e.googleId,
        policyName: e.policyName,
      } as MdmDeviceSchema,
    ])
  }
}

async function deleteDevice(e: MdmDeviceSchema): Promise<void> {
  if (window.confirm(`WARNING: Do you want to delete device with IMEI: ${e.imei}?`)) {
    await store.dispatch('deleteMdmDevice', e)
    await router.replace('/devices')
  }
}

function formatPolicyName(id: string): string {
  return mdmPolicies.value.find(m => m.googleId === id)?.name
}

return (_ctx: any,_cache: any) => {
  const _component_PrimeDropdown = _resolveComponent("PrimeDropdown")!
  const _component_DodoIcon = _resolveComponent("DodoIcon")!
  const _component_DodoButton = _resolveComponent("DodoButton")!
  const _component_DodoRow = _resolveComponent("DodoRow")!
  const _component_DodoCard = _resolveComponent("DodoCard")!
  const _component_DodoTabs = _resolveComponent("DodoTabs")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    (mdmDevice.value != null && googleDevice.value != null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_DodoCard, null, {
            default: _withCtx(() => [
              _hoisted_3,
              _createVNode(_component_DodoRow, null, {
                default: _withCtx(() => [
                  _createVNode(_component_PrimeDropdown, {
                    modelValue: mdmDevice.value.policyName,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((mdmDevice.value.policyName) = $event)),
                    options: mdmPolicies.value,
                    loading: mdmPolicies.value == null,
                    "option-value": "googleId",
                    "option-label": "name",
                    placeholder: "Select a policy",
                    disabled: !googleDevice.value.id,
                    style: {"min-width":"20%"}
                  }, null, 8, ["modelValue", "options", "loading", "disabled"]),
                  _createVNode(_component_DodoButton, {
                    variant: "solid",
                    disabled: !googleDevice.value.id,
                    color: "info",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (updateMdmDevicePolicy(mdmDevice.value)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DodoIcon, {
                        name: "checkmark",
                        fill: ""
                      }),
                      _createTextVNode(" Save ")
                    ]),
                    _: 1
                  }, 8, ["disabled"]),
                  _createVNode(_component_DodoButton, {
                    variant: "solid",
                    color: "danger",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (deleteDevice(mdmDevice.value)))
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_DodoIcon, {
                        name: "delete",
                        fill: ""
                      }),
                      _createTextVNode(" Delete ")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (mdmDevice.value.expectedPolicyName)
                ? (_openBlock(), _createBlock(_component_DodoRow, { key: 0 }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_4, "Expected policy: " + _toDisplayString(mdmDevice.value.expectedPolicyName), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_DodoCard, null, {
            default: _withCtx(() => [
              _hoisted_5,
              _createVNode(_component_DodoTabs, { tabs: [
            { name: 'General', slot: 'general' },
            { name: 'Enrollment', slot: 'enrollment' },
            { name: 'Hardware', slot: 'hardware' },
            { name: 'Software', slot: 'software' },
            { name: 'Network', slot: 'network' },
            { name: 'Security', slot: 'security' },
          ] }, _createSlots({ _: 2 }, [
                _renderList(_unref(groupedDeviceDetails), (group, groupName) => {
                  return {
                    name: groupName,
                    fn: _withCtx(() => [
                      _createVNode(DeviceDetailsTable, {
                        group: group,
                        "group-name": groupName
                      }, null, 8, ["group", "group-name"])
                    ])
                  }
                })
              ]), 1024)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})